import type {z} from 'zod';
import type {RelatedCommunitiesSchema} from '../../../../../core/entities/companyDetail/schema';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  companyID: number;
  companyName?: string;
  relatedCommunities: z.infer<typeof RelatedCommunitiesSchema>;
};

export const RelatedCommunities: React.FC<Props> = ({
  companyID,
  companyName,
  relatedCommunities,
}) => {
  if (companyName === null || relatedCommunities.length === 0) {
    return null;
  }

  return (
    <div className="w-[100%]">
      <h2
        id="related-communities"
        className="text-black-1 text-lg font-bold leading border-collapse border-l-8 border-l-primary-1 px-12 py-16 text-left mt-12"
      >
        {companyName}に関連するコミュニティ
      </h2>
      <Communities communities={relatedCommunities} />
      {/* 3件以上ある場合、全ての口コミを見る導線表示 */}
      {relatedCommunities.length > 2 && (
        <div className="text-center mt-16 mb-32">
          <CommonLink
            href={`/company/${companyID}/communities`}
            className="text-link-1 hover:underline"
          >
            すべての口コミを見る
          </CommonLink>
        </div>
      )}
    </div>
  );
};

// コミュニティ表示
const Communities = ({
  communities,
}: {
  communities: z.infer<typeof RelatedCommunitiesSchema>;
}) => {
  if (communities.length === 0) {
    return null;
  }

  const showCommunities = communities.slice(0, 2);

  return (
    <ul className="pt-16 px-12 min-w-[90%] mx-auto">
      {showCommunities.map((community) => {
        const showComments = community.comments?.slice(0, 2);
        return (
          <li key={community.id} className="p-0 mt-4 mb-16">
            <CommonLink
              className="text-link-1 hover:underline"
              href={`/questions/${community.id}`}
            >
              {community.title}
            </CommonLink>
            {showComments?.map((comment) => {
              return (
                <div key={comment.id} className="pl-8 py-8 bg-black-5 mb-4">
                  <p>{comment.content}</p>
                  <div className="text-xs text-black-2 py-4 flex justify-between">
                    <div>{comment.author}</div>
                    <div className="pr-8">{comment.createdAt}</div>
                  </div>
                </div>
              );
            })}
          </li>
        );
      })}
    </ul>
  );
};
